import { render, staticRenderFns } from "./SnippetCard.vue?vue&type=template&id=4a7d5a28&scoped=true&"
import script from "./SnippetCard.vue?vue&type=script&lang=ts&"
export * from "./SnippetCard.vue?vue&type=script&lang=ts&"
import style0 from "./SnippetCard.vue?vue&type=style&index=0&id=4a7d5a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d5a28",
  null
  
)

export default component.exports